import axios from 'axios'

/**
 * Performs an AJAX request to the given URL with the given JSON data in its body and returns a Promise which eventually
 * resolves or rejects to one of the given callbacks onSuccess or onError. The function calls the onPending callback
 * before performing the request to the API.
 *
 * @param {object} json JSON Object to send to the API.
 * @param {string} url The URL string to send the request to.
 * @param {function(response: string)} onSuccess Callback to use when the request succeeds.
 * @param {function(string | ErrorEvent)} onError Callback to use when the request fails.
 * @param {function} onPending Callback without arguments to call before starting the request.
 * @param {string} token
 * @param {string} type
 * @returns {Promise<any>} Fulfills after the request succeeds or fails.
 */
export const postToApi = async (
  json = {},
  url = null,
  onSuccess = null,
  onError = () => {},
  onPending = () => {},
  token = ''
) => {
  if (!url || !onSuccess || typeof onSuccess !== 'function') {
    throw new Error("url and onSuccess can't be null or empty")
  }
  await onPending()
  const headers = {
    'Content-Type': 'application/json',
    token
  }
  const jsonString = JSON.stringify(json)
  return axios
    .post(url, jsonString, { headers })
    .then((response) => {
      const { status, data } = response
      return onSuccess({ data, status })
    })
    .catch((error) => {
      if (error.response !== undefined) {
        const { status, data } = error.response
        return onError({ data, status })
      }
      const status = null
      const data = {}
      return onError({ data, status })
    })
}
